export const deleteExpandableTablesData = (props) => {
  const {
    selectedVal,
    entityData,
    setEntityData,
  } = props.dataObject;
  const { tables, allowedConditionValues } = props.operation;
  if (tables && allowedConditionValues.includes(selectedVal)) {
    let hasTableData = false;
    tables.forEach((table) => {
      if (entityData && entityData[table]) {
        hasTableData = true;
        delete entityData[table];
      }
    });
    if (hasTableData && typeof setEntityData === 'function') {
      setEntityData({ ...entityData });
    }
  }
};
